import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

export const getVendorCodesandNames = async ({ UID, RID, VendorType, prefix }) => {
    try {
        const response = await axios.get(`${base}/Reports/GetVendorCodesandNames`, { params: { UID, RID, VendorType, prefix } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch vendors';
    }
};

export const getVendorBalanceSummaryReportGrid = async ({ FromDate, ToDate, VendorCode }) => {
    try {
        const response = await axios.get(`${base}/Reports/VendorBalanceSummaryReportGrid`, { params: { FromDate, ToDate, VendorCode: VendorCode || undefined } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch vendor balance report';
    }
};
